// HTML template helpers for the public-accommodation controller.
//
// These render the small bits of UI that live inside the controller's
// "summary" target. They are pure functions: given state in, return an
// HTML string out. The controller is responsible for sticking the result
// into the DOM and for any side effects (event wiring goes through
// data-action attributes rendered into the markup here).
//
// Locale strings come in via the `locales` object (wired from the server
// in Task 11.5). The fallbacks here keep the UI sensible until that lands.

export function stalePromptHtml(earliest, latest, locales = {}) {
  const range = formatRange(earliest, latest)
  const notice = locales.stale_notice || "Your accommodation no longer covers your dive dates."
  const prefix = locales.repick_cta_prefix || "Re-pick accommodation for"
  return `
    <div class="alert alert-warning small d-flex justify-content-between align-items-center accom-stale-prompt">
      <span>${escapeHtml(notice)}</span>
      <button type="button" class="btn btn-sm btn-accent"
              data-action="public-accommodation#openPickerPrefilled"
              data-prefill-check-in="${earliest}"
              data-prefill-check-out="${addDays(latest, 1)}">
        ${escapeHtml(prefix)} ${escapeHtml(range)}
      </button>
    </div>`
}

export function selectedSummaryHtml(state, locales = {}) {
  const { roomType, checkIn, checkOut, rooms, nights, rateCents } = state
  const roomsLabel = rooms > 1 ? `, ${rooms} rooms` : ""
  const priceSuffix = (rateCents != null)
    ? ` — $${(nights * rooms * rateCents / 100).toFixed(2)}`
    : ""
  const removeLabel = locales.remove || "Remove"
  const safeRoom = escapeHtml(roomType || "")
  return `
    <div class="d-flex align-items-center justify-content-between p-3 rounded"
         style="background: rgba(16,185,129,0.08); border: 1px solid rgba(16,185,129,0.25);">
      <div>
        <div class="fw-medium" style="color: #6ee7b7;">${safeRoom}</div>
        <div class="small" style="color: rgba(110,231,183,0.7);">${checkIn} to ${checkOut} (${nights} nights${roomsLabel})${priceSuffix}</div>
      </div>
      <button type="button" class="btn btn-sm btn-outline-danger"
              data-action="public-accommodation#removeAccommodation">${escapeHtml(removeLabel)}</button>
    </div>`
}

export function formatRange(earliest, latest) {
  const fmt = d => new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" })
  if (earliest === latest) return fmt(earliest)
  return `${fmt(earliest)} – ${fmt(latest)}`
}

export function addDays(yyyyMmDd, n) {
  const d = new Date(yyyyMmDd + "T00:00:00")
  d.setDate(d.getDate() + n)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const dd = String(d.getDate()).padStart(2, "0")
  return `${y}-${m}-${dd}`
}

function escapeHtml(str) {
  const div = document.createElement("div")
  div.textContent = str
  return div.innerHTML
}
